<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.5"
      y="9.5"
      width="12"
      height="6"
      rx="3"
      transform="rotate(-45 2.5 9.5)"
      stroke="#2F7F91"
      stroke-width="2"
    />
    <rect
      x="9.5"
      y="16.5"
      width="12"
      height="6"
      rx="3"
      transform="rotate(-45 9.5 16.5)"
      stroke="#2F7F91"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {}
</script>
